import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    email: '',
    user: [],
    answers: [],
    answerTexts: [{
      'title' : 'Mal.',
      'number': '0%',
      'quote': 'Veo que lo tuyo no son los fierros y los hitos deportivos, pero seguro la música te hace vibrar. Ingresa tus datos y participa por entradas dobles para Ana Tijoux en el Peugeot 208 Music.'
    }, {
      'title': 'Mal.',
      'number': '20%',
      'quote': 'Veo que lo tuyo no son los fierros y los hitos deportivos, pero seguro la música te hace vibrar. Ingresa tus datos y participa por entradas dobles para Ana Tijoux en el Peugeot 208 Music.'
    }, {
      'title': 'Mal.',
      'number': '40%',
      'quote': 'Veo que lo tuyo no son los fierros y los hitos deportivos, pero seguro la música te hace vibrar. Ingresa tus datos y participa por entradas dobles para Ana Tijoux en el Peugeot 208 Music.'
    }, {
      'title': 'Más o menos',
      'number': '60%',
      'quote': 'Nada mal, se nota que el deporte te apasiona. Ahora es tiempo de vibrar con la música. Ingresa tus datos y participa por entradas dobles para Ana Tijoux en el Peugeot 208 Music.'
    }, {
      'title': '¡Excelente! Tú sí sabes de Peugeot y de deporte.',
      'number': '80%',
      'quote': 'Ahora te invitamos a vibrar con la música. Ingresa tus datos y participa por entradas dobles para Ana Tijoux en el Peugeot 208 Music.'
    }, {
      'title': '¡Excelente! Tú sí sabes de Peugeot y de deporte.',
      'number': '100%',
      'quote': 'Ahora te invitamos a vibrar con la música. Ingresa tus datos y participa por entradas dobles para Ana Tijoux en el Peugeot 208 Music.'
    }],
    questions: [
      {
        title: '¿Qué campeonato deportivo se asocia al 208?',
        badtext: 'Mal. El evento deportivo asociado al 208 es Roland Garros',
        id: 1,
        options: [
        {
          id: 'a',
          text: 'Champions League',
          correct: false
        },
        {
          id: 'b',
          text: 'Roland Garros',
          correct: true
        },
        {
          id: 'c',
          text: 'Tour de France',
          correct: false
        },
        {
          id: 'd',
          text: 'Juegos Olímpicos',
          correct: false
        },
        {
          id: 'e',
          text: 'Mundial de Atletismo',
          correct: false
        }
        ],
      },
      {
        title: '¿Qué piloto estableció un récord en Pikes Peak al mando de un 208?',
        badtext: 'No es así. El piloto es Sébastien Loeb',
        id: 2,
        options: [{
            id: 'a',
            text: 'Petter Solberg',
            correct: false
          },
          {
            id: 'b',
            text: 'Michael Schumacher',
            correct: false
          },
          {
            id: 'c',
            text: 'Colin McRae',
            correct: false
          },
          {
            id: 'd',
            text: 'Sébastien Loeb',
            correct: true
          },
          {
            id: 'e',
            text: 'Fernando Alonso',
            correct: false
          }
        ],
      },
      {
        title: '¿Qué auto maneja “Chaleco” López en la serie R5 del rally?',
        badtext: 'Nop. La Nave de Chaleco es la T16',
        id: 3,
        options: [{
            id: 'a',
            text: '208 R1',
            correct: false
          },
          {
            id: 'b',
            text: '208 GTi',
            correct: false
          },
          {
            id: 'c',
            text: '208 T16',
            correct: true
          },
          {
            id: 'd',
            text: '208 R2',
            correct: false
          },
          {
            id: 'e',
            text: '208 A15',
            correct: false
          }
        ],
      },
      {
        title: '¿Cuál es el consumo del 208 1.6 BlueHDi?',
        badtext: 'Sí, es verdad. El 208 1.6 BlueHDi da 25,4 km por litro.',
        id: 4,
        options: [{
            id: 'a',
            text: '15,2 km/l',
            correct: false
          },
          {
            id: 'b',
            text: '20.3 km/l',
            correct: false
          },
          {
            id: 'c',
            text: '25,4 km/l',
            correct: true
          },
          {
            id: 'd',
            text: '32 km/l',
            correct: false
          },
          {
            id: 'e',
            text: '18,6 km/l',
            correct: false
          }
        ],
      },
      {
        title: '¿Cuándo llegó a Chile el Peugeot 208?',
        badtext: 'Es más cerca de lo que parece. El 208 llegó a Chile en 2012.',
        id: 5,
        options: [{
            id: 'a',
            text: '2008',
            correct: false
          },
          {
            id: 'b',
            text: '2009',
            correct: false
          },
          {
            id: 'c',
            text: '2010',
            correct: false
          },
          {
            id: 'd',
            text: '2011',
            correct: false
          },
          {
            id: 'e',
            text: '2012',
            correct: true
          }
        ],
      }
    ]
  },
  mutations: {
    SET_EMAIL: (state, email) => {
      state.email = email
    },
    SET_ANSWER: (state, answer) => {
      state.answers.push(answer)
    }
  },
  actions: {
    setEmail : (context, email) => {
      context.commit("SET_EMAIL", email)
    },
    setAnswer: (context, answer) => {
      context.commit("SET_ANSWER", answer)
    }
  },
  getters: {
    getQuestion: (state) => (key) => {
      return state.questions[key]
    },
    getAnswers: (state) => {
      return state.answers
    },
    actualQuestion: (state, getters) => {
      const answers = getters.getAnswers
      const answersLength = answers.length || 0
      if(answersLength >= state.questions.length) {
        return false;
      } else {
        return getters.getQuestion(answersLength)
      }
    },
    answerText: (state) => (key) => {
      return state.answerTexts[key];
    },
    getScore: (state, getters) => {
      const answers = getters.getAnswers
      return answers.filter(i => i.result === true).length;
    },
    getScoreTexts: (state, getters) => {
      const score = getters.getScore
      return getters.answerText(score)
    }
  }
})
